const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/settings/topics/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { topicsSearchSchema } from "@/react/components/SettingsApp/Topics/searchParams";
export const Route = createFileRoute("/_protected/_settingsLayout/settings/topics")({
  validateSearch: topicsSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});